import React from 'react'

const LinkNewWindow = ({ link, text }) => {
    if (!link || !text) {
        return null
    }
    return (
        <a href={link} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    )
}
export default LinkNewWindow
